globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.TextsCollectionRequestsController = (function(superClass) {

  utils.extend(TextsCollectionRequestsController, superClass);

  function TextsCollectionRequestsController() {
    return TextsCollectionRequestsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(TextsCollectionRequestsController.prototype, {
    init: function(){
      this.initEvents();

      return TextsCollectionRequestsController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var $form = $("form.text-item-form");
      var $textarea = $form.find('textarea');

      $textarea.each(function(){
        editor = CKEDITOR.replace($(this).attr('id'), {
          customConfig: $(this).data('ckeditor-config')
        });
      });

      if(CKEDITOR.instances.business_services_website_texts_collection_request_cms_page_text_items_attributes_0_text_content != undefined) {
        CKEDITOR.instances.business_services_website_texts_collection_request_cms_page_text_items_attributes_0_text_content.on('change', function(){
          saveTextItemContent(this, $textarea);
        })
      } else if(CKEDITOR.instances.business_services_website_texts_collection_request_cms_blog_article_text_items_attributes_0_text_content != undefined) {
        CKEDITOR.instances.business_services_website_texts_collection_request_cms_blog_article_text_items_attributes_0_text_content.on('change', function(){
          saveTextItemContent(this, $textarea);
        })
      } else if(CKEDITOR.instances.business_services_website_texts_collection_request_free_text_items_attributes_0_text_content != undefined) {
        CKEDITOR.instances.business_services_website_texts_collection_request_free_text_items_attributes_0_text_content.on('change', function(){
          saveTextItemContent(this, $textarea);
        })
      }

      function saveTextItemContent(ckeditor, $input) {
        var $textItemDetails = $input.closest('.text-item-details');
        var $textItemSaving = $textItemDetails.find('.text-item-saving');
        var $textItemSaved = $textItemDetails.find('.text-item-saved');
        var url = $textItemDetails.data("url");
        var textItemId = $textItemDetails.data("text-item-id");

        var textItemContent = ckeditor.getData();

        $.ajax({
          type: "POST",
          url: url,
          data: { text_item_id: textItemId, text_item_content: textItemContent },
          success: function(data)
          {
            if (data.response == 1) {
              $textItemSaving.show();
              $textItemSaved.hide();
              setTimeout(function() {
                $textItemSaving.hide();
                $textItemSaved.show();
                $textItemSaved.each(function(){
                    $(this).find('.text-item-saved-at').html(data.text_item_saved_at);
                })
              }, 500);
            } else {
              $textItemSaving.show()
            };
          }
        });
      };

      var $mainMediaImageContainer = $form.find('.main-media-image-container');
      var $selectMainMediaImageButton = $mainMediaImageContainer.find('.select-main-media-image-button');
      var $accountsMediaFileField = $mainMediaImageContainer.find('.accounts-media-file-field');

      $selectMainMediaImageButton.on('click', function(e){
        e.preventDefault();
        $accountsMediaFileField.find('button.open-modal').trigger('click');
        $accountsMediaFileField.parent().show();
        $(this).hide();
      });

      $accountsMediaFileField.on('change', 'input.file-id', function(){
        var url = $(this).closest('.main-media-image-field-tag').data('add-media-image-path');
        var main_media_image_id = $(this).val();

        if(url != undefined){
          $.ajax({
            type: "PATCH",
            url: url,
            data: { main_media_image_id: main_media_image_id },
            success: function(data) {
              if(data.response == 1) {
                console.log('success');
              } else {
                console.log('error');
              };
            }
          });
        }
      });

    }
  });

  return TextsCollectionRequestsController;

})(appCustomerSpace.Controllers.Websites.MainController);
